export default function Exclamation({size = 16, color = "#FF0000"}) {
  const width = size / 8
  const height = size * 5 / 8
  
  return (
    <svg width={width} height={height} viewBox="0 0 2 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0.000488281H1.99546V6.65584H0V0.000488281ZM0 7.76063H1.99546V9.97781H0V7.76063Z" fill={color}/>
    </svg>

  );
}
